/**
 * This component has the same look and feel as the TabMenu component, though semantically it doesn't use tabs, but a plain old list of links.
 */
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getReadableColor } from 'helpers/getContrast'
import styled from 'styled-components'

import HideVisually from 'js/components/HideVisually/HideVisually'

type StyleProps = {
    top?: number
    left?: number
}

const SkipLink = styled(HideVisually)<StyleProps>`
    position: absolute;

    &:focus,
    &:active {
        top: ${(p) => p.style?.top ?? 4}px;
        left: ${(p) => p.style?.left ?? 4}px;
        width: auto;
        height: 40px;

        margin: 0;
        padding: 0 12px;
        background-color: ${(p) => p.theme.color.pleio};

        font-size: ${(p) => p.theme.font.size.small};
        line-height: 40px;
        font-weight: ${(p) => p.theme.font.weight.semibold};
        color: white;
        outline: none;

        clip: auto;
        z-index: 14;

        outline-color: ${(p) =>
            getReadableColor(p.theme.color.header.main)} !important;
    }
`

type SkipNavigationLinkProps = {
    contentId: string
    style?: StyleProps
}

const SkipNavigationLink = ({ contentId, style }: SkipNavigationLinkProps) => {
    const { t } = useTranslation()

    return (
        <SkipLink as="a" href={`#${contentId}`} style={style}>
            {t('action.skip-to-content')}
        </SkipLink>
    )
}

export default SkipNavigationLink
